var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInvitationUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6673 14.6396L8.33398 14.6459L5.83398 16.6667V19.1667H34.1673V16.6667L31.6673 14.6396Z",
    fill: "#FFAD24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.834 5.8335H9.16732C8.70708 5.8335 8.33398 6.20659 8.33398 6.66683V25.8335C8.33398 26.2937 8.70708 26.6668 9.16732 26.6668H30.834C31.2942 26.6668 31.6673 26.2937 31.6673 25.8335V6.66683C31.6673 6.20659 31.2942 5.8335 30.834 5.8335Z",
    fill: "#FFFAEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0402 25.9876L5.83398 16.6667V32.5001C5.83398 33.4209 6.57982 34.1667 7.50065 34.1667H32.5007C33.4215 34.1667 34.1673 33.4209 34.1673 32.5001V16.6667L20.9611 25.9876C20.384 26.3938 19.6152 26.3938 19.0381 25.9876H19.0402Z",
    fill: "#FFC82A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.002 14.625C21.2791 14.625 22.3145 13.5897 22.3145 12.3125C22.3145 11.0353 21.2791 10 20.002 10C18.7248 10 17.6895 11.0353 17.6895 12.3125C17.6895 13.5897 18.7248 14.625 20.002 14.625Z",
    fill: "#FFAD24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2641 19.5833C21.5579 19.5833 18.4433 19.5833 16.737 19.5833C16.0454 19.5833 15.5329 18.9187 15.7349 18.2562C16.2954 16.4354 17.9933 15.2188 20.0016 15.2188C22.0099 15.2188 23.7079 16.4354 24.2683 18.2562C24.4724 18.9167 23.9579 19.5833 23.2662 19.5833H23.2641Z",
    fill: "#FFAD24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8984 22.6397L6.35254 33.7064C6.65254 33.9918 7.05671 34.1689 7.50254 34.1689H32.5025C32.9484 34.1689 33.3525 33.9918 33.6525 33.7064L21.1046 22.6418C20.4755 22.0855 19.5296 22.0855 18.9005 22.6418L18.8984 22.6397Z",
    fill: "#FFDA67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvitationUser);
export default __webpack_public_path__ + "static/media/icon_invitation_user.cdc99fa4.svg";
export { ForwardRef as ReactComponent };